export var ProductType;
(function (ProductType) {
    ProductType["BOOK"] = "book";
    ProductType["STATIONERY"] = "stationery";
    // Easy to add: GIFT = 'gift', ACCESSORY = 'accessory'
})(ProductType || (ProductType = {}));
//  Simple type guard (if you need it)
export const isBook = (product) => product.productType === ProductType.BOOK;
export const isStationery = (product) => product.productType === ProductType.STATIONERY;
